import * as React from 'react';
import { IMedia, IVideoclubStat } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Favorite from '../components/parts/Favorite';
import { Redirect } from 'react-router';
import Clip from '../components/items/Clip';
import Comments from '../components/parts/Comments';
import Vote from '../components/parts/Vote';
import { withTranslation } from 'react-i18next';
import i18n from '../config/i18next';
import Banner from '../components/parts/Banner';

interface IState {
    media: IMedia,
    isLoading: boolean,
    name: string,
    media_id: number,
    related: IMedia[],
    frames: string[],
    options: any,
    isStatLoading: boolean,
    stat: IVideoclubStat[],
    isNotFound: boolean,
}

class VideoclibView extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;
    private videoNode: any;
    private player: any;

    constructor(props: any) {
        super(props);

        this.state = {
            media: null,
            isLoading: true,
            name: this.props.match.params.name,
            media_id: this.props.match.params.media_id,
            related: [],
            isNotFound: false,
            frames: [],
            options: {
                loop: false,
                margin: 5,
                autoHeight: true,
                nav: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    400: {
                        items: 2
                    },
                    600: {
                        items: 2
                    },
                    1000: {
                        items: 4
                    }
                },
            },
            isStatLoading: true,
            stat: []
        };
    }

    clips() {
        let clips = [];

        for (let i = 0; i < this.state.related.length; i += 2) {
            clips.push(
                <div className="item" key={i}>
                    <Clip url="football" slide={this.state.related[i]} />
                    {this.state.related[i + 1] && <Clip url="football" slide={this.state.related[i + 1]} />}
                </div>
            );
        }

        return clips;
    }

    componentWillReceiveProps(props: any) {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "auto"
        });

        if (this.player) {
            this.player.dispose()
        }

        this.setState({
            name: props.match.params.name,
            media_id: props.match.params.media_id,
            isLoading: true,
            isStatLoading: true
        }, this.componentDidMount);
    }

    async componentDidMount() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/football/view?media_id=${this.state.media_id}`);

        $('#carusel6').owlCarousel("destroy");

        if (!this._isUnmounted)
            if (response.data.status == "success") {
                this.setState({
                    media: response.data.media,
                    isLoading: false,
                    related: response.data.related,
                    frames: response.data.frames,
                }, () => {
                    // @ts-ignore
                    this.player = window.videojs(this.videoNode, response.data.vast ? {
                        "plugins": {
                            "vastClient": {
                                "adCancelTimeout": 20000,// Wait for ten seconds before canceling the ad.
                                "adsEnabled": true,
                                "adTagUrl": `https://${window.location.host}/api/default/vast?media_id=${this.state.media_id}`
                            }
                        }
                    } : this.props);

                    this.player.ready(function () {
                        this.hotkeys({
                            volumeStep: 0.1,
                            seekStep: 10,
                            enableMute: true,
                            enableFullscreen: true,
                            enableNumbers: false,
                            enableVolumeScroll: true,
                            enableHoverScroll: true,

                            // Mimic VLC seek behavior, and default to 5.
                            // @ts-ignore
                            seekStep: function (e: any) {
                                if (e.ctrlKey && e.altKey) {
                                    return 5 * 60;
                                } else if (e.ctrlKey) {
                                    return 60;
                                } else if (e.altKey) {
                                    return 10;
                                } else {
                                    return 5;
                                }
                            },

                            // Enhance existing simple hotkey with a complex hotkey
                            fullscreenKey: function (e: any) {
                                // fullscreen with the F key or Ctrl+Enter
                                return ((e.which === 70) || (e.ctrlKey && e.which === 13));
                            },

                        });
                    });

                    this.player.landscapeFullscreen();

                    this.player.play();
                    this.carouselInit();
                });


            } else {
                this.setState({
                    isNotFound: true
                });
            }
    }

    componentWillUnmount() {
        this._isUnmounted = true;

        if (this.player) {
            this.player.dispose()
        }
    }

    carouselInit() {
        $('#carusel6').owlCarousel(this.state.options);

        $(window).ready(function () {
            setTimeout(function () {
                $('.owl-carousel').trigger('refresh.owl.carousel');
                $("a.watch").trigger("click");
            }, 50);
        });
    }

    downloadFile() {
        window.open(`${config.site}/site/upload/${this.state.media_id}?type=download`);
    }

    render() {
        const { t } = this.props;

        return (
            <div className="i-body">
                {this.state.isNotFound && <Redirect to="/not-found" />}
                <div className="container v-index">
                    <div className="wrapper">
                        <div className="player">
                            {!this.state.isLoading && <div data-vjs-player className="w-100">
                                <video id="vid" ref={node => this.videoNode = node} className="video-js vjs-default-skin" controls preload="auto" data-setup='{}' width={"100%"} height={"634px"}>
                                    <source src={this.state.media.videofile} type='video/mp4' />
                                    <p>Video Playback Not Supported</p>
                                </video>
                            </div>}
                        </div>

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}

                        {!this.state.isLoading && (<div className="wrap games watch">
                            <h3>
                                <span>{this.state.media.fullname}</span>
                                <span> </span>
                                <Favorite className="favorite-tab" media={this.state.media} />
                            </h3>
                            <hr />
                            <div className="row">
                                <div className="col-md-8 col-xs-12">
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <div className="left_box left_box_video">

                                                <Vote media_id={this.state.media_id} />

                                                <a onClick={(e: any) => {
                                                    e.preventDefault();

                                                    this.downloadFile();
                                                }} style={{ width: "100%", marginTop: "57px", position: "absolute", left: 0, zIndex: 1000 }} className="down btn btn-primary fs-20">
                                                    {t("Скачать")} <i className="fa fa-download"></i>
                                                </a>
                                                <a style={{ visibility: "hidden", height: 0, width: 0 }} data-file={this.state.media.videofile} data-media_id={this.state.media_id} data-age="16+" data-message="Есть возрастное ограничение к этому видео. Вам уже больше 18 ?" className="watch btn btn-primary fs-20">
                                                    {t("Смотреть")} <i className="fa fa-play"></i>
                                                </a>
                                            </div>
                                        </div>
                                        <div className="col-sm-7">
                                            <div className="info">
                                                <ul className="fs-16">
                                                    <li>
                                                        <span className="w-120px">{t("Загрузки")}:</span>
                                                        <span>{this.state.media.download}</span>
                                                    </li>
                                                    <li>
                                                        <span className="w-120px">{t("Просмотры")}:</span>
                                                        <span>{this.state.media.reviews}</span>
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix"></div>
                                </div>
                                <div className="col-md-4 col-xs-12">
                                    <Banner className="banner235" place={29} style={{ margin: 0 }} />

                                </div>
                            </div>
                        </div>)}

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}

                        <div className="films klips recommend">

                            <nav>
                                <div>
                                    <a className="film"> {t("Также рекомендуется")} </a>
                                </div>
                                <div></div>
                            </nav>

                            {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                            {this.state.related.length > 0 && <div className="owl-carousel box_list " id="carusel6">
                                {this.clips()}
                            </div>}

                        </div>

                        <Banner className="banner235" place={30} />
                        <Banner className="banner235" place={31} />

                        <Comments media_id={this.state.media_id} />

                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(VideoclibView);